/* eslint no-template-curly-in-string: 0 */
export default {
  mixed: {
    default: 'Valor inválido.',
    required: 'Éste es un campo obligatorio.',
    oneOf: '${path} debe tener uno de los siguientes valores: ${values}.',
    notOneOf: '${path} no debe tener ninguno de los siguientes valores: ${values}.',
    notType: ({ path, type, value, originalValue }) => {
      switch (type) {
        case 'number':
          return `El valor debe ser un número.`;
        default:
          return 'Valor inválido';
      }
    },
  },
  string: {
    email: 'Ingrese un email correcto.',
    url: 'Debe ser una URL válida',
  },
  number: {
    positive: 'Debe ser un número mayor que 0',
  },
  date: {
    min: 'Ingrese una fecha mayor',
    max: 'Ingrese una fecha menor',
  },
};

/**
mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: ({ path, type, value, originalValue }) => {
    let isCast = originalValue != null && originalValue !== value;
    let msg =
      `${path} must be a \`${type}\` type, ` +
      `but the final value was: \`${printValue(value, true)}\`` +
      (isCast
        ? ` (cast from the value \`${printValue(originalValue, true)}\`).`
        : '.');

    if (value === null) {
      msg += `\n If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
    }

    return msg;
  },
};

string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string',
};

number = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  lessThan: '${path} must be less than ${less}',
  moreThan: '${path} must be greater than ${more}',
  notEqual: '${path} must be not equal to ${notEqual}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer',
};

date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}',
};

boolean = {};

object = {
  noUnknown: '${path} field cannot have keys not specified in the object shape',
};

array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items',
};
 */
